<!--
 * @Author: awu
 * @Date: 2020-11-15 17:17:42
 * @LastEditors: awu
 * @LastEditTime: 2020-11-18 23:27:00
 * @Description: 小会议厅-企业介绍
-->
<template>
  <div class="about">
        <div class="backHome" @click="backHome">
            <img src="../../assets/close.png" alt="">
        </div>
        <h1 class="h1">中国电信股份有限公司</h1>
        <h2 class="h2">{{about.h2}}</h2>
        <div class="basicWapper">
            <div class="img"></div>
            <div class="msg">
                <p>
                    <span>{{about.msg1}}:</span><span>9089万</span>
                </p>
                <p>
                    <span>{{about.msg2}}:</span><span>10000</span>
                </p>
                <p>
                    <span>{{about.msg3}}:</span><span>www.baidu.com</span>
                </p>
                <p>
                    <span>{{about.msg4}}:</span><span>户外家具</span>
                </p>
                <p>
                    <span>{{about.msg5}}:</span><span>欧美</span>
                </p>
            </div>
        </div>
        <div class="textWapper">
            <h2 class="h2">{{about.h2}}</h2>
            <p class="text">
                中国电信集团有限公司（英文名称“China Telecom”、简称“中国电信”）成立于2000年9月，是中国特大型国有通信企业、上海世博会全球合作伙伴，连续多年入选"世界500强企业"，主要经营固定电话、移动通信、卫星通信、互联网接入及应用等综合信息服务。
截至2019年12月，拥有固定电话用户1.10亿户，移动电话用户3.35亿户，宽带用户 1.5亿户；集团公司总资产7109.64亿元，员工总数40余万人。 
[1]	2019年6月6日，工信部正式向中国电信发放5G商用牌照。 
[2] 	2020年5月13日，作为第一批倡议方，与国家发展改革委等部门发起“数字化转型伙伴行动”倡议。
            </p>
        </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{
        backHome() {
            this.$router.push("/exhibition/smallconference");
            this.$root.$emit('close') 
        },
    },
    computed: {
        about() {
            return this.$t("about");
        }
    },
}
</script>

<style lang="scss" scoped>
    .about{
        width: 667px;
        height: 440px;
        background-color: #ffffff;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50% , -50%);
        box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
        border-radius: 30px;
        box-sizing: border-box;
        padding: 15px 20px 27px;
        .h1{
            width: 100%;   
            height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5F7185;
            line-height: 28px;
            text-align: center;
            margin-bottom: 20px;
        }
        .h2{
            width: 100%;
            height: 22px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #5F7185;
            line-height: 22px;
            margin-bottom: 13px;
        }
        .basicWapper{
            width: 100%;
            height: 133px;
            display: flex;
            align-items: flex-start;
            justify-content: flex-start;
            margin-bottom: 20px;
            .img{
                width: 187px;
                height: 100%;
                flex-shrink: 0;
                background-color: #aaa;
            }
            .msg{
                margin-left: 13px;          
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #5F7185;
                line-height: 24px;
                span:last-of-type{
                    margin-left: 12px;
                }
            }
        }
        .textWapper{
            .text{    
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #5F7185;
                line-height: 21px;
                text-align: justify;
            }
        }
    }
    .backHome {
        width: 33px;
        height: 33px;
        border-radius: 50%;
        background-color: #4F8AF8;
        position: absolute;
        top: -8px;
        right: -13px;
        >img{
            width: 100%;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/conference/smallIntroduce.vue